//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {apiUrl, apiParams} from "@/const/const"
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
    name: 'LoadImgLading',
    components: {
        MyBtnReturn
    },
    data() {
        return {
            bookingId: '',
            ladingId: '',
            servicetype: '', // “拖车”、“货代”等服务类型
            src1: require('@/assets/images/plan/wx_zhuang_blue.png'), // 装箱的图片，右上角的icon
            // src2: require('@/assets/images/plan/wx_chai_oringe.png'), // 拆箱的图片
            uploadLoadSrc: require('@/assets/images/wx_zx_tp.png'), // 装箱图片，上传图片的那个图标，如果用户上传了，就替代下
            uploadSealSrc: require('@/assets/images/wx_fx_tp.png'), // 封箱图片，上传图片的那个图标，如果用户上传了，就替代下
            iconClose: require('@/assets/images/wx_sc_oringe.png'), // 关闭图标
            tableData: [
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'zzzz',
                //   loadimgisupload: 0,
                //   sealimgisupload: 1,
                // },
                // {
                //   id: 'AD154654',
                //   contNo: 'ajdfkadfjakl',
                //   contId: 'aaaaa',
                //   loadimgisupload: 1,
                //   sealimgisupload: 0,
                // },
            ],
            isShowTable: true,
            isShowLoading: false,
            isNoData: false,
        }
    },
    created() {
        document.title = '装货图片';
        let query = this.$route.query;
        this.bookingId = query.bookingId;
        this.ladingId = query.ladingId;
        this.servicetype = query.servicetype;
        this.getData()
    },
    methods: {
        getData() {
            // 获取工作单下要上传图片的柜，一个工作单可能有多个柜号id
            let data = {
                openId: apiParams.openId,
                companyId: apiParams.companyId,
                code: apiParams.code,
                ladingId: this.ladingId,
                servicetype: this.servicetype,
            };
            this.isShowLoading = true;
            // 调用接口获取数据
            this.requestApi({
                url: apiUrl.loadImgLading,
                data: data
            }, (resultData) => {
                this.ladingId = resultData.data.ladingId; // 已经通过路由获得，这行可有可无
                // 一个工作单有多个柜号id(即多条柜)，因此sonos是数组，这里应该不会出现空数组的情况
                this.tableData = resultData.data.sonos || []
            }, (error) => {
                this.isShowLoading = false;
                if (error) {
                    console.error(error); // 请求出错时，在这里log比较好，才能立即找到是哪个函数出错
                }
            })
        },
        goNextPage(routerName, id, referenceno, contNo, contId, type) {
            // 按钮的方法，跳转上传或查看页面，并且带些参数过去
            // todo 有个bug，在这层跳转到下一个页面时，会感觉到先关闭当前窗口，然后重新打开一个窗口？导致数据丢失，而且用go回退时要两次！
            // 但有时候又是直接一次跳转成功，奇怪！

            this.$router.push({
                name: routerName,
                // path: '/load-img-upload',
                query: {
                    bookingId: this.bookingId,
                    ladingId: this.ladingId,
                    servicetype: this.servicetype,
                    id: id,
                    referenceno: referenceno,
                    contNo: contNo,
                    contId: contId,
                    type: type, // 为了区分装箱与封箱，load为装箱，seal为封箱,loaddoc为单证图片
                    companyId2: apiParams.companyId,
                    openId2: apiParams.openId,
                }
            })
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/siji/loadImg/LoadImgLading.vue